import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = {
  class: "alert alert-primary alert-dismissible fs-md-15 fs-lg-16",
  role: "alert"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = { class: "col-md-12" }
const _hoisted_21 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "boitePostaleForm",
        onSubmit: $setup.addBoitePostale,
        "validation-schema": $setup.boitePostaleSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                ($setup._totalBoite == '0001')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _cache[1] || (_cache[1] = _createTextVNode(" Le bureau ", -1)),
                      _createElementVNode("strong", null, _toDisplayString($setup._bureau), 1),
                      _cache[2] || (_cache[2] = _createTextVNode(", dispose d'une boîte dont le numéro est le 0001 ", -1)),
                      _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      ($setup._totalBoite == '0000')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _cache[4] || (_cache[4] = _createTextVNode(" Le bureau ", -1)),
                            _createElementVNode("strong", null, _toDisplayString($setup._bureau), 1),
                            _cache[5] || (_cache[5] = _createTextVNode(", ne dispose pas encore de boite ", -1)),
                            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _cache[7] || (_cache[7] = _createTextVNode(" Le bureau ", -1)),
                            _createElementVNode("strong", null, _toDisplayString($setup._bureau), 1),
                            _createTextVNode(", dispose des boîtes numérotées de 0001 à " + _toDisplayString($setup._totalBoite) + " ", 1),
                            _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1))
                          ]))
                    ])),
                _cache[9] || (_cache[9] = _createElementVNode("button", {
                  type: "button",
                  class: "btn-close shadow-none",
                  "data-bs-dismiss": "alert",
                  "aria-label": "Close"
                }, null, -1))
              ])
            ], 512), [
              [_vShow, $setup.informationShow]
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Bureau "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "bureau" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: $setup.bureauOptions,
                      searchable: true,
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.changeBureau($event))),
                      onOpen: $setup.onOpen,
                      placeholder: "Sélectionner le bureau"
                    }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onOpen"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "bureau",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Modèle de boîte "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "modele" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: $setup.modeleOptions,
                      searchable: true,
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { placeholder: "Sélectionner le modèle de boîte" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "modele",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Nombre de boîte "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "nbrBoite",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le nombre de boîte"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "nbrBoite",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Couleur ", -1)),
                _createVNode(_component_Field, {
                  name: "couleur",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer la couleur"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "couleur",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Dimension ", -1)),
                _createVNode(_component_Field, {
                  name: "dimension",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer la dimension"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "dimension",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[16] || (_cache[16] = _createElementVNode("div", {
                  class: "btn-group me-20",
                  style: {"max-height":"45px"}
                }, [
                  _createElementVNode("button", {
                    class: "default-btn mh-3 transition border-0 lh-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                    type: "submit"
                  }, " Générer des boîtes postales ")
                ], -1)),
                _createVNode(_component_router_link, {
                  to: "/liste-boites",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}